import {typedObjectKeys} from '@stryd/util-lib';

import {ValidRegionCode} from 'src/config';
import {LineItem, RegionalCart} from 'src/features/cart/types';
import {
  isStryd5ClipsAddOnAvailable,
  isStryd5ClipsProductSlug,
} from 'src/features/product/helpers/stryd5ClipsAvailability';

export const withoutUnavailableStryd5Clips = (
  lineItems: LineItem[],
  region: ValidRegionCode,
): LineItem[] => {
  if (isStryd5ClipsAddOnAvailable(region)) return lineItems;

  const next = lineItems.filter(
    (item) => !isStryd5ClipsProductSlug(item.product.fields.slug),
  );

  return next.length === lineItems.length ? lineItems : next;
};

/** Drops out-of-stock clip packs from restricted stores. Other line items stay. */
export const stripUnavailableStryd5Clips = (
  cart: RegionalCart,
): RegionalCart => {
  let next: RegionalCart | null = null;

  for (const region of typedObjectKeys(cart)) {
    const regionalCart = cart[region];
    const lineItems = withoutUnavailableStryd5Clips(
      regionalCart.lineItems,
      region,
    );
    if (lineItems === regionalCart.lineItems) continue;

    if (!next) next = {...cart};
    next[region] = {...regionalCart, lineItems};
  }

  return next ?? cart;
};
